import React, {memo} from "react";
import {Tag} from "antd";
import {getFileColor} from "../../../../../../Common/util/ColorUtil";

interface MemoizedTagProps {
    text: string;
}


const MemoizedTag:React.FC<MemoizedTagProps>  = memo(({ text }) => (
    <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Tag color={getFileColor(text)} key={text.toUpperCase()}>
            {text.toUpperCase()}
        </Tag>
    </div>
));
export default MemoizedTag;